import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

export const RejectAcceptHeader = () => {
  const { t } = useTranslation()

  return (
    <Tooltip
      label={
        <Flex flexDirection="column">
          <Text weight="bold" color={Color.White}>
            {t('copilot.table.accept_or_reject.tooltip.title')}
          </Text>
          <Text color={Color.White}>{t('copilot.table.accept_or_reject.tooltip')}</Text>
        </Flex>
      }
      placement="right"
    >
      <Flex alignItems="center" gap={Spacing.S4}>
        <Text weight="medium">{t('copilot.table.accept_or_reject')}</Text>
        <Icon icon="info" color={Color.Black} />
      </Flex>
    </Tooltip>
  )
}
